<template>
  <v-app>
    <div id="app">
      <Header/>
      <router-view/>
      <Footer />
    </div>
  </v-app>
</template>

<script>
const Header = () => import(/* webpackPrefetch: true */ "@/components/Header");
const Footer = () => import(/* webpackPrefetch: true */ "@/components/Footer");

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>
